import React, { Fragment, useEffect, useLayoutEffect, useMemo, useRef } from 'react';
import ReactPDF, {
  Font,
  Image,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  pdf,
} from '@react-pdf/renderer';
import { logo_dof } from 'components/base/images';

import styled from '@react-pdf/styled-components';
import { color } from 'styles/utils';
import { icon_user_circle, invoice_left_bar, invoice_title } from 'components/base/images';
import moment from 'moment';
import { addCommas } from 'lib/library';
import T from 'components/common/text/T';
import { genderList } from 'lib/mapper';
import { calculateAge } from 'lib/library';
import TeethSvgForPdf from 'components/common/teeth/clinic/TeethSvgForPdf';

const styles = StyleSheet.create({
  tableRowEven: {
    padding: '5px 10px',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tableRowOdd: {
    padding: '5px 10px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(206, 210, 223, 0.60)',
  },
  headerLogoBox: {
    width: 70,
    marginBottom: 18,
  },
});

Font.register({
  family: 'Noto Sans KR',
  fonts: [
    {
      src: require('static/fonts/notosanskr/NotoSansKR-Regular.woff'),
      fontStyle: 'normal',
      fontWeight: 400,
    },
    {
      src: require('static/fonts/notosanskr/NotoSansKR-Medium.woff'),
      fontStyle: 'normal',
      fontWeight: 500,
    },
    {
      src: require('static/fonts/notosanskr/NotoSansKR-Bold.woff'),
      fontStyle: 'normal',
      fontWeight: 700,
    },
  ],
});

const PageContainer = styled.Page`
  font-family: 'Noto Sans KR';
  border: none;
  background-color: #fff;
  width: 100%;
  padding-bottom: 45px;
`;
const HeaderSection = styled.View`
  width: 100%;
  height: 138px;
  background-color: rgba(204, 237, 249, 0.3);
  padding: 30px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
`;
const HeaderLeft = styled.View`
  padding-top: 10px;
`;
const HeaderRight = styled.View`
  flex-direction: column;
`;

const HedaerTitleUnderLine = styled.View`
  margin-top: 18px;
  width: 100%;
  height: 10px;
  background-color: #ced2df;
`;

const HeaderAddressBox = styled.View``;
const HeaderAddress = styled.View`
  flex-direction: row;
`;

const ProjectInfoSection = styled.View`
  padding: 0 40px;
  flex-direction: row;
  justify-content: space-between;
`;
const InformationBox = styled.View``;

const PatientInfoBox = styled.View`
  margin-bottom: 45px;
`;

const OrderInfoBox = styled.View`
  margin-bottom: 45px;
`;

const RemakeBox = styled.View`
  margin-bottom: 0;
  flex-direction: row;
`;

const RemakeInfoBox = styled.View`
  width: 40px;
  position: absolute;
  top: 0;
  left: 0;
`;

const MemoBox = styled.View`
  margin-bottom: 30px;
  width: 350px;
  white-space: pre-wrap;
  word-break: break-all;
  overflow-wrap: anywhere;
`;
const IndicationTeethBox = styled.View`
  width: 140px;
  height: 100%;
`;

const TeethSection = styled.View`
  padding: 0 40px 45px 40px;
  overflow: hidden;
`;

const TableHeader = styled.View`
  padding: 7px 10px;
  background-color: rgba(204, 237, 249, 0.4);
`;

const TableHeaderRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;

const TableRowCol1 = styled.View`
  width: 40px;
`;

const TableRowCol2 = styled.View`
  width: 150px;
`;

const TableRowCol3 = styled.View`
  width: 40px;
`;

const TableRowCol4 = styled.View`
  width: 150px;
`;

const TableBody = styled.View``;

const TextWrapper = styled.View`
  flex-direction: row;
`;

const TextHeaderAddressLable = styled.Text`
  font-size: 10px;
  color: #444;
  font-weight: 400;
  width: 30px;
  margin-right: 5px;
`;

const TextHeaderAddress = styled.Text`
  font-size: 10px;
  color: #444;
  font-weight: 400;
  width: 200px;
`;

const TextHeaderTitle = styled.Text`
  font-size: 40px;
  color: #25256f;
  font-weight: 500;
`;
const TextInfoTitle = styled.Text`
  font-size: 14px;
  color: #25256f;
  font-weight: 700;
  margin-bottom: 8px;
`;

const TextInfo = styled.Text`
  font-size: 10px;
  color: #444;
  font-weight: 400;
  margin-bottom: 4px;
`;

const TextMemo = styled.Text`
  font-size: 10px;
  color: #444;
  font-weight: 400;
  width: 350px;
`;

const TextTableHeader = styled.Text`
  font-size: 14px;
  color: #25256f;
  font-weight: 600;
`;

const TextTableBody = styled.Text`
  font-size: 10px;
  color: #25256f;
  font-weight: 400;
`;
const ProductionRequestPdfDoc = ({
  language,
  projectInfo,
  user,
  teeth,
  bridge,
  partList,
  materialList,
}) => {
  const userMemo = useMemo(() => {
    const memosplit = projectInfo.senderMemo?.split('\n');
    const memo = [];
    // memosplit?.map(item => {
    //   const size = 40;
    //   const split = Math.floor(item.length / size) + 1;
    //   for (let i = 0; i < split; i++) {
    //     memo.push(item.slice(i * size, (i + 1) * size));
    //   }
    // });
    if (!!memosplit && memosplit.length > 0) {
      for (let j = 0; j < memosplit.length; j++) {
        const size = 40;
        const split = Math.floor(memosplit[j].length / size) + 1;
        for (let i = 0; i < split; i++) {
          memo.push(memosplit[j].slice(i * size, (i + 1) * size));
        }
      }
    }
    return memo;
  }, [projectInfo]);

  const scanDate = useMemo(() => {
    if (!projectInfo.timeline?.scan) {
      return '-';
    } else if (language === 'en') {
      return moment.unix(projectInfo.timeline?.scan).locale(language).format('MMM DD, YYYY');
    } else {
      return moment.unix(projectInfo.timeline?.scan).locale(language).format('YYYY.MM.DD');
    }
  }, [projectInfo, language]);

  const completeDueDate = useMemo(() => {
    if (!projectInfo.dueDate) {
      return '-';
    } else if (language === 'en') {
      return moment.unix(projectInfo.dueDate).locale(language).format('MMM DD, YYYY');
    } else {
      return moment.unix(projectInfo.dueDate).locale(language).format('YYYY.MM.DD');
    }
  }, [projectInfo, language]);

  const indiactionList =
    useMemo(() => {
      return teeth?.map(item => {
        const indicationName = partList?.find(part => part.alias === item.indicationAlias)?.name;
        const materialName = materialList?.find(
          material => material.alias === item.materialAlias,
        )?.name;

        return { ...item, indicationName, materialName };
      });
    }, [teeth, partList, materialList]) || [];

  const remakes =
    useMemo(() => {
      return projectInfo.ownerRemakeType;
    }, [projectInfo]) || [];

  return (
    <Document>
      <PageContainer>
        <HeaderSection fixed>
          <HeaderLeft>
            <Image src={logo_dof} style={styles.headerLogoBox} />
            <HeaderAddressBox>
              <HeaderAddress style={{ marginBottom: 5 }}>
                <TextHeaderAddressLable>{'Addr.'}</TextHeaderAddressLable>
                <TextHeaderAddress>
                  {`${!!user?.city ? user.city : ''} ${!!user?.district ? user.district : ''} ${
                    !!user?.address ? user.address : ''
                  }`}
                </TextHeaderAddress>
              </HeaderAddress>
              <HeaderAddress>
                <TextHeaderAddressLable>{'FAX.'}</TextHeaderAddressLable>
                <TextHeaderAddress>{!!user?.phone ? user.phone : ''}</TextHeaderAddress>
              </HeaderAddress>
            </HeaderAddressBox>
          </HeaderLeft>
          <HeaderRight>
            <TextHeaderTitle>
              <T>PRODUCTION_REQUEST_TITLE</T>
            </TextHeaderTitle>
            <HedaerTitleUnderLine />
          </HeaderRight>
        </HeaderSection>
        <ProjectInfoSection>
          <InformationBox>
            <PatientInfoBox>
              <TextInfoTitle>
                <T>PRODUCTION_REQUEST_PATIENT_INFO</T>
              </TextInfoTitle>
              <TextInfo>{`${projectInfo?.patientInfo?.lastName}${projectInfo?.patientInfo?.firstName}`}</TextInfo>
              <TextInfo>
                {!!calculateAge(projectInfo.patientInfo?.birthday).age ||
                calculateAge(projectInfo.patientInfo?.birthday).age === 0
                  ? calculateAge(projectInfo.patientInfo?.birthday).age
                  : '-'}
              </TextInfo>
              <TextInfo style={{ marginBottom: 0 }}>
                {genderList[projectInfo?.patientInfo?.gender]}
              </TextInfo>
            </PatientInfoBox>
            <OrderInfoBox>
              <TextInfoTitle>
                <T>PRODUCTION_REQUEST_ORDER_INFO</T>
              </TextInfoTitle>
              <TextInfo>{projectInfo?.syncInfo?.partnerName}</TextInfo>

              <TextWrapper>
                <TextInfo>
                  <T>PRODUCTION_REQUEST_SCAN_DATE</T>
                </TextInfo>
                <TextInfo style={{ margin: '0 5px' }}>{':'}</TextInfo>
                <TextInfo style={styles.textInfo}>{scanDate}</TextInfo>
              </TextWrapper>
              <TextWrapper style={styles.textWrapper}>
                <TextInfo style={{ color: '#00A6E2' }}>
                  <T>PRODUCTION_REQUEST_DUE_DATE</T>
                </TextInfo>
                <TextInfo style={{ color: '#00A6E2', margin: '0 5px' }}>{':'}</TextInfo>
                <TextInfo style={{ color: '#00A6E2' }}>{completeDueDate}</TextInfo>
              </TextWrapper>
              <RemakeBox>
                <TextInfo>
                  <T>GLOBAL_REMAKE</T>
                </TextInfo>
                <TextInfo style={{ margin: '0 5px' }}>{':'}</TextInfo>
                <RemakeInfoBox>
                  {remakes.length > 0 ? (
                    remakes.map((item, idx) => {
                      return <TextInfo key={idx}>{item.remakeTypeName}</TextInfo>;
                    })
                  ) : (
                    <TextInfo>
                      <T>GLOBAL_NONE</T>
                    </TextInfo>
                  )}
                </RemakeInfoBox>
              </RemakeBox>
            </OrderInfoBox>
            <MemoBox>
              <TextInfoTitle>
                <T>PROJECT_MEMO</T>
              </TextInfoTitle>
              {userMemo?.map((item, idx) => {
                return <TextMemo key={idx}>{item}</TextMemo>;
              })}
            </MemoBox>
          </InformationBox>
          <IndicationTeethBox>
            <TeethSvgForPdf teeth={teeth} bridge={bridge} />
          </IndicationTeethBox>
        </ProjectInfoSection>
        <TeethSection>
          <TableHeader fixed>
            <TableHeaderRow>
              <TableRowCol1>
                <TextTableHeader>
                  <T>PRODUCTION_REQUEST_NUMBER</T>
                </TextTableHeader>
              </TableRowCol1>
              <TableRowCol2>
                <TextTableHeader>
                  <T>PRODUCTION_REQUEST_INDICATION</T>
                </TextTableHeader>
              </TableRowCol2>
              <TableRowCol3>
                <TextTableHeader>
                  <T>PRODUCTION_REQUEST_SHADE</T>
                </TextTableHeader>
              </TableRowCol3>
              <TableRowCol4>
                <TextTableHeader>
                  <T>PRODUCTION_REQUEST_MATERIAL</T>
                </TextTableHeader>
              </TableRowCol4>
            </TableHeaderRow>
          </TableHeader>
          <TableBody>
            {indiactionList?.map((item, idx) => {
              const rowStyle = !!(idx % 2) ? styles.tableRowOdd : styles.tableRowEven;
              return (
                <View style={rowStyle} key={idx}>
                  <TableRowCol1>
                    <TextTableBody>{item.number}</TextTableBody>
                  </TableRowCol1>
                  <TableRowCol2>
                    <TextTableBody>{item.indicationName}</TextTableBody>
                  </TableRowCol2>
                  <TableRowCol3>
                    <TextTableBody>{item.shade.code}</TextTableBody>
                  </TableRowCol3>
                  <TableRowCol4>
                    <TextTableBody>{item.materialName}</TextTableBody>
                  </TableRowCol4>
                </View>
              );
            })}
          </TableBody>
        </TeethSection>
      </PageContainer>
    </Document>
  );
};

export default React.memo(ProductionRequestPdfDoc);
